import { render, staticRenderFns } from "./AdvertismentEdit.vue?vue&type=template&id=68181e52&scoped=true&"
import script from "./AdvertismentEdit.vue?vue&type=script&lang=js&"
export * from "./AdvertismentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68181e52",
  null
  
)

export default component.exports